var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"px-3"},[_c('v-list-item',{on:{"click":() => {}}},[_c('v-list-item-title',[_vm._v("Member-only Forum")])],1),_c('v-list-item',{on:{"click":() => {}}},[_c('v-list-item-title',[_vm._v("Listen to stories of our dancers")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }